import { observer, Observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import OperatorViewModel from "../../../../viewModels/notice/components/operator/operatorViewModel";
import { registerView, View } from "@frui.ts/views";
import { Col, Form } from "react-bootstrap";
import { RadioArray } from "../../../../controls/radioArray";
import RepresentativeTypeSelect from "./representativeTypeSelect";

const OperatorView: FunctionComponent<{
  vm: OperatorViewModel;
}> = observer(({ vm }) => {
  return (
    <fieldset className="mb-4">
      <legend className="h3">{vm.translate("operator")}</legend>
      <RepresentativeTypeSelect vm={vm} />
      {vm.isRepresentedAsProxy && (
        <>
          <p className="pb-1 font-size-sm">{vm.translate("operatorDescription")}</p>
          <Form.Row className="mt-4 mb-3">
            <Form.Group as={Col} xs={"auto"} className="mb-3">
              <RadioArray
                custom
                label={vm.translate("individual")}
                target={vm}
                property="isLegalPerson"
                isNumeric={false}
                option={false}
                id={"individual"}
                className="mr-7"
              />
            </Form.Group>
            <Form.Group as={Col} xs={"auto"} className="mb-3">
              <RadioArray
                custom
                label={vm.translate("legal")}
                target={vm}
                property="isLegalPerson"
                isNumeric={false}
                id={"legal"}
                option={true}
              />
            </Form.Group>
          </Form.Row>
          <Observer>{() => <View vm={vm.activeChild} />}</Observer>
        </>
      )}
    </fieldset>
  );
});

registerView(OperatorView, OperatorViewModel);
